export const urls = {
  file: {
    token: "/pmiapi/public/getuploadtoken",
  },
  recruit: {
    add: "/fund/recruit/add",
  },
  // 获取当前版本号
  apiversion: "/pmiapi/public/apiversion",
  // 获取Token
  getuploadtoken: "/pmiapi/unauth/masterdata/getuploadtoken",
  // 刷新Token
  refreshtoken: "/pmiapi/public/refreshtoken",
  // 获取Jssdk
  jssdkconfig: "/pmiwx/public/mp/jssdk/config",
  // 通过体验券二维码信息获取卡券信息
  voucherdetail: "/pmiapi/public/voucher/detail",
  // 扫码体验券充值
  voucherputin: "/pmiapi/public/voucher/putin",
  // 查询充值结果
  vouchergetputinresult: "/pmiapi/public/voucher/getputinresult",
  // ?
  accountvoucherdetail: "/pmiapi/public/account/voucher/detail",
  // ?
  accountvouchertransfer: "/pmiapi/public/account/voucher/transfer",
  // 扫码
  qrcodescan: "/pmiapi/unauth/qrcode/scan",
  // 获取短信验证码
  getsmscode: "/pmiapi/public/getsmscode",
  // 登入
  login: "/pmiapi/public/login",
  // 获取分享商家详情
  getShareCompanyDetail: "/pmiapi/public/company/detail",
  // 商家详情
  getcompanyid: "/pmiapi/public/getcompanyid",
  // 依据授权码获取信息
  getShareInfo: "/pmiapi/public/share/getinfobyauthcode",
  // 【V4.0】【分享】H5注册用户提交（含普通邀请注册、红包邀请注册、赠送领取和商品领取）
  userSubmit: "/pmiapi/public/personal/invitation/register",
  // 【V4.0】获取注册、红包注册和赠送领用结果
  getSubmitResult: "/pmiapi/public/personal/share/invitation/getinviteresult",
  // ？
  setUser: "/pmiapi/unauth/personal/info/change",
  // 被邀请人
  getinvite: "/pmiapi/public/personal/invitation/register",
  // 邀请人的个人信息
  invitationUserInfo: "/pmiapi/public/personal/invitation/userinfo",
  // 获取邀请的二维码链接
  qucodeurl: "/pmiapi/unauth/personal/share/invitation/qrcode/url",
  // 微信公众号登入
  weiChatLogin: "/pmiwx/public/mp/oauth2/login",
  // 微信手机号
  weiChatPhone: "/pmiwx/public/mp/oauth2/binding/phone",
  // ?
  getRedirectUrl: "/pmiwx/public/mp/oauth2/url",
  // 获取安卓下载地址
  getAndroidUrl: "pmiapi/public/androidapk",
  // 动态详情
  dynamicDetail: "pmiapi/public/dynamic/detail",
  // 动态详情评论
  commentList: "pmiapi/public/dynamic/comment/list",
  // 用户投诉
  userComplain: "pmiapi/public/personal/save/user/complain",
  // 手机号是否已注册（public）
  checkMobile: "/pmiapi/public/personal/check/phone",
  // 年度考核（V2）
  evaluation: "/pmrest/public/evaluation/getYearScoreRankV2",
  // 个人资料查询
  userQuestionDetail: "/pmiapi/public/personal/userQuestion/detail",
  // 个人资料提交
  userQuestionAdd: "/pmiapi/public/personal/userQuestion/add",
  // 个人资料提交
  userQuestionh5Add: "/pmiapi/public/personal/userQuestion/h5/add",
  // 个人资料提交
  userQuestionh5detail: "/pmiapi/public/personal/userQuestion/h5/detail",
  // 个人资料配置信息
  userQuestionh5config: "/pmiapi/public/personal/userQuestion/h5/config",
  // 个人实名认证
  userCertification: "/pmiapi/public/personal/certification",
};



// WEBPACK FOOTER //
// ./src/api/apiUrlConfig.js